'use es6';

import { createSelector } from 'reselect';
import { fromJS, List } from 'immutable';
import requestStatusType from '../constants/requestStatusTypes';
import { selectSavedReports, selectReportsRequestStatus, selectRestorableReports, selectRestorableReportsRequestStatus } from './reportsSelector';
import { selectFavoriteReportsStatus } from '../redux/favorites';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
export const selectTableDataStatus = createSelector(selectFavoriteReportsStatus, selectReportsRequestStatus, (favoriteReportsStatus, reportsStatus) => {
  if (reportsStatus === SUCCEEDED && favoriteReportsStatus === SUCCEEDED) {
    return SUCCEEDED;
  } else if (reportsStatus === PENDING || favoriteReportsStatus === PENDING) {
    return PENDING;
  } else if (reportsStatus === UNINITIALIZED || favoriteReportsStatus === UNINITIALIZED) {
    return UNINITIALIZED;
  } else {
    return FAILED;
  }
});
export const selectTableData = createSelector(selectTableDataStatus, selectSavedReports, (tableDataStatus, reports) => {
  return tableDataStatus === SUCCEEDED ? fromJS(reports) : List();
});
export const selectRestoreTableData = createSelector(selectRestorableReportsRequestStatus, selectRestorableReports, (requestStatus, reports) => {
  if (requestStatus === SUCCEEDED) {
    return fromJS(reports);
  } else {
    return List();
  }
});